// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__2GFeP","footer":"ChangeClinic_footer__WjcRF"};